import type { SearchType } from '@beaded/shared-lib/src/searchTerms'

/**
 * Global search paging (docs/specs/2026-10-15-paged-global-search.md): the
 * first response brings this many rows per type.
 */
export const SEARCH_PAGE_SIZE = 100

/** The rest of a type is then fetched in the background in pages of this many. */
export const SEARCH_BACKGROUND_PAGE_SIZE = 1000

export type { SearchType }
